import { render, staticRenderFns } from "./ScrollFadeIn.vue?vue&type=template&id=67f5f5c5&scoped=true"
import script from "./ScrollFadeIn.vue?vue&type=script&lang=js"
export * from "./ScrollFadeIn.vue?vue&type=script&lang=js"
import style0 from "./ScrollFadeIn.vue?vue&type=style&index=0&id=67f5f5c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f5f5c5",
  null
  
)

export default component.exports